import LinedInput, {InputType} from "./LinedInput";
import maskInput from "../lib/maskInput";
import masks from "../constants/masks";
import React from "react";

type Props = React.ComponentProps<"input"> & {
    setValue: (s: string) => void;
    id: string;
    value: string;
    label: string;
    extraInfo?: string;
    validationMessage?: string[];
    showValidIcon?: boolean;
};

function PhoneInput({setValue, ...rest}: Props, ref: React.ForwardedRef<HTMLInputElement>) {
    function handleChangeWithMask(e: React.ChangeEvent<HTMLInputElement>) {
        const value = e.target.value;
        setValue(maskInput(masks.phone.pattern, value));
    }

    return (
        <LinedInput
            {...rest}
            onChange={handleChangeWithMask}
            maxLength={masks.phone.pattern.length}
            pattern={masks.phone.regex}
            type={InputType.Text}
            ref={ref}
        />
    );
}

export default React.forwardRef<HTMLInputElement, Props>(PhoneInput);
